import { createActions } from 'redux-actions';

export const {
  bootstrap,
  setIdentifier
} = createActions({
  bootstrap: () => undefined,
  setIdentifier: identifier => identifier
}, { prefix: 'BUS_TICKETS' });
